export const AMAZON = 'amazon';
export const EBAY = 'ebay';
export const ETSY = 'etsy';
export const FAIRE = 'faire';
export const SHOPIFY = 'shopify';
export const SQUARESPACE = 'squarespace';
export const WIX = 'wix';
export const WOOCOMMERCE = 'woocommerce';

export const CHANNEL_BY_ID = {
  1: ETSY,
  2: SHOPIFY,
  3: EBAY,
  4: FAIRE,
};

export const CHANNEL_ID = {
  [EBAY]: 3,
  [ETSY]: 1,
  [FAIRE]: 4,
  [SHOPIFY]: 2,
};

export const CHANNEL_NAME = {
  [AMAZON]: 'Amazon',
  [EBAY]: 'eBay',
  [ETSY]: 'Etsy',
  [FAIRE]: 'Faire',
  [SHOPIFY]: 'Shopify',
  [SQUARESPACE]: 'Squarespace',
  [WIX]: 'WIX',
  [WOOCOMMERCE]: 'WooCommerce',
};

export const CHANNEL_COLOR = {
  [AMAZON]: 'rgb(255, 154, 0)',
  [EBAY]: 'rgb(9, 104, 246)',
  [ETSY]: 'rgb(242, 102, 34)',
  [FAIRE]: 'rgb(0, 0, 0)',
  [SHOPIFY]: 'rgb(149, 191, 71)',
  [WOOCOMMERCE]: 'rgb(155, 92, 143)',
};
